module.exports = __webpack_public_path__ + "img/mail-dist.24cb3ea9.svg";